import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import Adminnavbar from "../Adminnavbar";

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [titleOrder, setTitleOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);

  /* ================= GET BLOG DATA ================= */
  const getBlogData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/blog`
      );
      if (res.status === 200) {
        setBlogs(res.data.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getBlogData();
  }, []);

  /* ================= SEARCH + SORT ================= */
  useEffect(() => {
    let data = [...blogs];

    if (searchQuery) {
      data = data.filter((item) =>
        item.title?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    data.sort((a, b) =>
      titleOrder === "asc"
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title)
    );

    setFilteredBlogs(data);
    setCurrentPage(0);
  }, [blogs, searchQuery, titleOrder]);

  /* ================= PAGINATION ================= */
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBlogs.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredBlogs.length / itemsPerPage);

  const handlePageClick = ({ selected }) => setCurrentPage(selected);

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this blog",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/blog/delete/${id}`
        );
        Swal.fire("Deleted!", "Blog deleted successfully", "success");
        getBlogData();
      } catch (error) {
        Swal.fire("Error", "Delete failed", "error");
      }
    }
  };

  /* ================= IMAGE FALLBACK ================= */
  const handleImgError = (e) => {
    e.target.src = "/assets/img/images.jpg";
  };

  return (
    <>
      <Adminnavbar />

      <div className="page-wrapper page-settings">
        <div className="content">
          {/* BREADCRUMB */}
          <nav
            aria-label="breadcrumb"
            style={{ "--bs-breadcrumb-divider": "none" }}
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/admindashbord">Dashboard</NavLink> /
              </li>
              <li className="breadcrumb-item active">Knowledge Center</li>
            </ol>
          </nav>

          {/* HEADER */}
          <div className="content-page-header d-flex justify-content-between align-items-center">
            <h5>Knowledge Center</h5>
            <Link to="/create-knowledge-center" className="btn btn-primary">
              <i className="fa fa-plus me-2"></i>Create
            </Link>
          </div>

          {/* SEARCH */}
          <div className="col-lg-4 mb-3">
            <input
              className="form-control"
              placeholder="Search By Title"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>

                  {/* TITLE SORT */}
                  <th>
                    <span className="d-flex align-items-center justify-content-center gap-2">
                      Title
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setTitleOrder(titleOrder === "asc" ? "desc" : "asc")
                        }
                      >
                        {titleOrder === "asc" ? "▲" : "▼"}
                      </span>
                    </span>
                  </th>

                  <th>Description</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data found
                    </td>
                  </tr>
                ) : (
                  currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>

                      <td>
                        <img
                          src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}/uploads/blog/${item.photo}`}
                          alt={item.title}
                          width="70"
                          height="50"
                          style={{
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                          onError={handleImgError}
                        />
                      </td>

                      <td>{item.title}</td>

                      <td>
                        {item.description?.length > 60
                          ? item.description.slice(0, 60) + "..."
                          : item.description}
                      </td>

                      <td className="text-center">
                      <div className="table-actions d-flex justify-content-center align-items-center gap-1">

                          {/* VIEW */}
                          <Link
                            to={`/view-knowledge-center/${item.id}`}
                            className="delete-table view-icon"
                            title="View Blog"
                          >
                            <i className="fas fa-eye"></i>
                          </Link>

                          {/* EDIT */}
                          <Link
                            to={`/update-knowledge-center/${item.id}`}
                            className="delete-table edit-icon"
                            title="Edit Blog"
                          >
                            <i className="fas fa-edit"></i>
                          </Link>

                          {/* DELETE */}
                          <span
                            className="delete-table delete-icon"
                            title="Delete Blog"
                            onClick={() => handleDelete(item.id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          <ReactPaginate
            pageCount={pageCount}
            onPageChange={handlePageClick}
            previousLabel="Prev"
            nextLabel="Next"
            containerClassName="pagination justify-content-end mt-3"
            activeClassName="active"
            pageLinkClassName="page-link"
            previousLinkClassName="page-link"
            nextLinkClassName="page-link"
          />
        </div>
      </div>
    </>
  );
}
